export default __webpack_public_path__ + "static/media/book-open.2f29b40e.svg";